import { z } from 'zod';

import { regex_iso_date } from '../../../../utils/regex.utils';
import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-update-api/#sonstigeverbindlichkeit

	{
        "abloesen": Boolean,
        "antragstellerIds": [ String ],
        "bic": String,
        "datumErsteZahlung": LocalDate,
        "datumLetzteRate": LocalDate,
        "glaeubiger": String,
        "iban": String,
        "rateMonatlich": BigDecimal,
        "restschuld": BigDecimal,
        "schlussrate": BigDeciaml,
        "urspruenglicherKreditbetrag": BigDecimal
    }


*/
export const schemaEuropaceUpdateSonstigeVerbindlichkeit = z
    .object({
        abloesen: z.optional(z.boolean()),
        antragstellerIds: z.array(z.string().min(1)).min(1).max(2),
        bic: z.optional(z.string()),
        datumErsteZahlung: z.optional(z.string().regex(regex_iso_date)),
        datumLetzteRate: z.optional(z.string().regex(regex_iso_date)),
        glaeubiger: z.optional(z.string()),
        iban: z.optional(z.string()),
        rateMonatlich: z.optional(schemaBigDecimal),
        restschuld: z.optional(schemaBigDecimal),
        schlussrate: z.optional(schemaBigDecimal),
        urspruenglicherKreditbetrag: z.optional(schemaBigDecimal),
    })
    .strip();

export type SchemaEuropaceUpdateSonstigeVerbindlichkeit = z.infer<typeof schemaEuropaceUpdateSonstigeVerbindlichkeit>;
